export default __webpack_public_path__ + "static/media/prize-2-cn.cfbed7a7.webp";